import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import nodeAPI from '../../service/ApiServiceNode';
import { getApiErrorMessage } from '../../utils/errorUtils';

export default function MedicalCertificate() {
    const { id } = useParams();
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        setError('');

        async function openDocument() {
            if (!/^[1-9]\d*$/.test(id) || !Number.isSafeInteger(Number(id))) {
                setError('Invalid leave request');
                return;
            }
            try {
                const response = await nodeAPI.get(`/leave/requests/${id}/medical-certificate`);
                if (!active) return;
                const url = response.data?.data?.url;
                if (!url) throw new Error('Unable to open the medical certificate');
                window.location.replace(url);
            } catch (requestError) {
                if (active) setError(getApiErrorMessage(requestError, 'Unable to open the medical certificate'));
            }
        }

        openDocument();
        return () => { active = false; };
    }, [id]);

    return <p role={error ? 'alert' : 'status'}>{error || 'Opening medical certificate…'}</p>;
}
